<template>
  <ODialogBar @close="$emit('close')">
    <template v-slot:title>
      Histórico ─ <span class="tag" :class="color"> {{ title }}</span>
      <small v-if="id != null" class="grey--text text--lighten-1 ml-6"
        >#{{ id }}</small
      >
    </template>
  </ODialogBar>
</template>

<script>
import { translateType, translateColor } from '@/models/client-history'

export default {
  props: {
    type: {},
    subType: {},
    id: {}
  },
  computed: {
    color() {
      return translateColor({ type: this.type, subType: this.subType })
    },
    title() {
      return translateType({ type: this.type, subType: this.subType })
    }
  }
}
</script>

<style></style>
